import constantCreator, { promiseStates } from '~/utils/constantsCreator';
import api from '~/utils/api';

const constant = constantCreator.defineAction('article').defineAction;
const GET_ARTICLE = constant('GET_ARTICLE', promiseStates);

const initialState = {
  isLoading: true,
  isError: false,
  article: {},
  ebooks: []
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ARTICLE.PENDING:
      return {
        ...state,
        isLoading: true,
        isError: false,
      };
    case GET_ARTICLE.RESOLVED:
      return {
        ...state,
        isLoading: false,
        isError: false,
        article: action.data,
      };
    case GET_ARTICLE.REJECTED:
      return {
        ...state,
        isLoading: true,
        isError: true,
        error: action.error,
      };
    default:
      return state;
  }
};

export default reducer;

export const actions = {
  getArticle: slug => ({
    type: GET_ARTICLE,
    promise: api.get(`/articles/slug/${slug}`),
  }),
};
